import React, {useEffect, useState} from "react";
import {GrClose} from "react-icons/gr";
import {useForm} from "react-hook-form";
import Api from "../../Api/api";
import {toast} from "react-toastify";
import {useStateValue} from "../../states/StateProvider";
import {AES, enc} from "crypto-js";

const UpdateRole = ({userID, role, subRoles, email, isActive}) => {
    const [showModal, setShowModal] = useState(false);
    const [roleShort, setRoleShort] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingConsRole, setLoadingConsRole] = useState(false);
    const [consultantRoles, setConsultantRoles] = useState([]);
    const [isUserActive, setIsUserActive] = useState(isActive === '1');
    const [{userValidated, secretKey}, dispatch] = useStateValue();

    const {
        register, handleSubmit, watch, setValue, getValues, formState: {errors, isValid, touchedFields},
    } = useForm({mode: "onChange"});

    useEffect(() => {
        const roleMap = {
            'ExtDGG': 'ed', 'ExtRUV': 'er', 'ManDGG': 'md', 'ManRUV': 'mr', 'Controller': 'c', 'Internal': 'i'
        };
        const short = roleMap[role] || '';
        setRoleShort(short);
        setValue('role', short);
        setIsUserActive(isActive === '1');
        if (subRoles) {
            setValue('isSAdmin', subRoles.isSAdmin === '1');
            setValue('isMailservice', subRoles.isIMAdmin === '1' || subRoles.isICAdmin === '1');
            setValue('isUserAdmin', subRoles.isUserAdmin === '1');
        }
    }, [role, subRoles, isActive, setValue]);

    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8));

    useEffect(() => {
        if (subRoles) {
            setValue('isSAdmin', subRoles.isSAdmin === '1');
            setValue('isMailservice', subRoles.isIMAdmin === '1' || subRoles.isICAdmin === '1');
            setValue('isUserAdmin', subRoles.isUserAdmin === '1');
        }
    }, [watch('role')]);

    // Fetch consultant role when modal opens
    useEffect(() => {
        if (showModal && userID) {
            setLoadingConsRole(true);
            const formData = new FormData();
            formData.append('U_ID', userID);

            Api().post('/sp_getConsRole', formData)
                .then(res => {
                    const data = res.data;
                    console.log('=== sp_getConsRole API Response ===');
                    console.log('Full response:', res);
                    console.log('Response data:', data);
                    let roles = [];

                    if (Array.isArray(data) && data.length > 0) {
                        const roleData = data[0];
                        console.log('Processing role data:', roleData);

                        if (roleData.Berater === '1' || roleData.Berater === 1) {
                            console.log('Found Berater = 1, adding berater role');
                            roles.push('berater');
                        }
                        if (roleData.Planer === '1' || roleData.Planer === 1) {
                            console.log('Found Planer = 1, adding beraterPlanner role');
                            roles.push('beraterPlanner');
                        }

                        if (roleData.berater === '1' || roleData.berater === 1 || roleData.role === 'berater') {
                            roles.push('berater');
                        }
                        if (roleData.beraterPlanner === '1' || roleData.beraterPlanner === 1 || roleData.role === 'beraterPlanner') {
                            roles.push('beraterPlanner');
                        }

                        if (roleData.isPFB === '1' || roleData.isPFB === 1) {
                            roles.push('berater');
                        }
                        if (roleData.isPM === '1' || roleData.isPM === 1) {
                            roles.push('beraterPlanner');
                        }

                        if (typeof roleData.role === 'string') {
                            if (roleData.role.includes('berater') && !roleData.role.includes('Planner')) {
                                roles.push('berater');
                            }
                            if (roleData.role.includes('beraterPlanner')) {
                                roles.push('beraterPlanner');
                            }
                        }

                        if (roleData.consultantRole) {
                            if (roleData.consultantRole === 'berater') {
                                roles = ['berater'];
                            } else if (roleData.consultantRole === 'beraterPlanner') {
                                roles = ['beraterPlanner'];
                            } else if (roleData.consultantRole === 'both') {
                                roles = ['berater', 'beraterPlanner'];
                            }
                        }
                    } else if (data && typeof data === 'object') {
                        if (data.Berater === '1' || data.Berater === 1) {
                            roles.push('berater');
                        }
                        if (data.Planer === '1' || data.Planer === 1) {
                            roles.push('beraterPlanner');
                        }
                        if (data.berater === '1' || data.berater === 1) {
                            roles.push('berater');
                        }
                        if (data.beraterPlanner === '1' || data.beraterPlanner === 1) {
                            roles.push('beraterPlanner');
                        }
                    }

                    roles = [...new Set(roles)];
                    console.log('Final roles array:', roles);
                    console.log('Setting consultant roles to:', roles);
                    setConsultantRoles(roles);
                })
                .catch((error) => {
                    console.error('Error fetching consultant role:', error);
                })
                .finally(() => {
                    setLoadingConsRole(false);
                });
        }
    }, [showModal, userID]);

    const onSubmit = async (data) => {
        setLoading(true);
        data.userID = userID;
        data.isActive = isUserActive ? '1' : '0';

        // Handle Mailservice checkbox - set both IC and IM admins
        if (data.isMailservice) {
            data.isICAdmin = true;
            data.isIMAdmin = true;
        } else {
            data.isICAdmin = false;
            data.isIMAdmin = false;
        }
        delete data.isMailservice;

        if (consultantRoles.length > 0) {
            changeConsultantRole(consultantRoles, data);
        }

        Api().post('/changeRole', data).then(res => {
            const response = res.data[0];
            response.success ? toast.success(response.success) : toast.error(response.error);
            if (response.success) {
                setShowModal(false);
            }
        })
            .catch(() => toast.error('Fehler beim Ändern der Benutzerrolle!'))
            .finally(() => setLoading(false));
    };

    const changeConsultantRole = (roles, formData) => {
        const data = new FormData();
        data.append("email", email);
        data.append("userId", userID);
        roles.forEach(role => data.append("consultantRole[]", role));
        Api().post('/sp_changeConsRole', data).then(res => {
            const response = res.data[0];
            if (response && response[""]) {
                toast.success(response[""]);
                setShowModal(false);
            } else {
                toast.error(response?.error || 'Unbekannter Fehler beim Aktualisieren der Berater-Rolle');
            }
        })
            .catch(() => toast.error('Fehler beim Ändern der Berater-Rolle!'))
            .finally(() => setLoading(false));
    };

    const selectedRole = watch('role');

    return (<>
            <button
                className='border mr-4 border-lightBlueDark bg-lightBlueDark rounded-3xl px-3 pt-1 pb-1 text-white text-center font-extrabold uppercase cursor-pointer'
                onClick={() => {
                    setConsultantRoles([]);
                    setShowModal(true);
                }}
            >
                Rolle ändern
            </button>

            {showModal && (<div className="fixed inset-0 z-[60] flex items-center justify-center bg-text bg-opacity-50">
                    <div className="relative w-full max-w-lg bg-white p-6 rounded-lg shadow-lg mx-4">
                        <GrClose
                            className="cursor-pointer absolute top-4 right-4"
                            size="22px"
                            onClick={() => setShowModal(false)}
                        />
                        <h2 className="text-left text-xl font-bold mb-6">Rolle ändern</h2>

                        <form onSubmit={handleSubmit(onSubmit)}>
                            <input type="hidden" value={userID} {...register('userID')} />
                            <input type="hidden" value={roleShort} {...register('oldRole')} />

                            {/* Role Selection with Radio Buttons - 3 Columns */}
                            <div className="mb-4 text-left">
                                <label className="block font-medium mb-3">Rolle auswählen *</label>
                                <div className="space-y-3">
                                    <div className="flex gap-x-6">
                                        <label className="flex items-center cursor-pointer w-32">
                                            <input
                                                type="radio"
                                                value='md'
                                                {...register('role', {required: 'Ihre Rolle ist erforderlich'})}
                                                className="mr-2"
                                            />
                                            Management
                                        </label>
                                        <label className="flex items-center cursor-pointer w-32">
                                            <input
                                                type="radio"
                                                value='mr'
                                                {...register('role', {required: 'Ihre Rolle ist erforderlich'})}
                                                className="mr-2"
                                            />
                                            Struktur
                                        </label>
                                        <label className="flex items-center cursor-pointer w-32">
                                            <input
                                                type="radio"
                                                value='c'
                                                {...register('role', {required: 'Ihre Rolle ist erforderlich'})}
                                                className="mr-2"
                                            />
                                            Controlling
                                        </label>
                                    </div>
                                    <div className="flex gap-x-6 items-start">
                                        <label className="flex items-center cursor-pointer w-32">
                                            <input
                                                type="radio"
                                                value='er'
                                                {...register('role', {required: 'Ihre Rolle ist erforderlich'})}
                                                className="mr-2"
                                            />
                                            FKB
                                        </label>
                                        <label className="flex items-center cursor-pointer w-32">
                                            <input
                                                type="radio"
                                                value='ed'
                                                {...register('role', {required: 'Ihre Rolle ist erforderlich'})}
                                                className="mr-2"
                                            />
                                            VP
                                        </label>
                                        <div className="w-32">
                                            <label className="flex items-center cursor-pointer mb-3">
                                                <input
                                                    type="radio"
                                                    value='i'
                                                    {...register('role', {required: 'Ihre Rolle ist erforderlich'})}
                                                    className="mr-2"
                                                />
                                                Innendienst
                                            </label>
                                            {selectedRole === 'i' && user.isUserAdmin === '1' && (
                                                <div className="ml-6 space-y-2">
                                                    {user.isSAdmin === '1' && (
                                                        <label className="flex items-center cursor-pointer">
                                                            <input type="checkbox" {...register("isSAdmin")} className="mr-2"/>
                                                            SuperAdmin
                                                        </label>
                                                    )}
                                                    <label className="flex items-center cursor-pointer">
                                                        <input type="checkbox" {...register("isUserAdmin")} className="mr-2"/>
                                                        Benutzerverwaltung
                                                    </label>
                                                    <label className="flex items-center cursor-pointer">
                                                        <input type="checkbox" {...register("isMailservice")} className="mr-2"/>
                                                        Mailservice (IC+IM)
                                                    </label>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {errors.role && touchedFields &&
                                    <p className="text-red-500 text-sm mt-2">{errors.role.message}</p>}
                            </div>

                            {/* PFB-Rolle Section */}
                            <div className="mb-6 text-left">
                                <label className="block font-medium mb-2">PFB-Rolle</label>
                                {loadingConsRole ? (
                                    <div className="flex items-center text-gray-500">
                                        <span className="mr-2">Lade Berater-Rolle...</span>
                                    </div>
                                ) : (
                                <div className="flex space-x-4">
                                    <label className="flex items-center cursor-pointer">
                                        <input
                                            type="checkbox"
                                            value="berater"
                                            checked={consultantRoles.includes("berater")}
                                            className="mr-2"
                                            onChange={(e) => {
                                                const updated = e.target.checked ? [...consultantRoles.filter(v => v !== ""), "berater"] : consultantRoles.filter(v => v !== "berater");
                                                setConsultantRoles(updated);
                                            }}
                                        />
                                        PFB
                                    </label>
                                    <label className="flex items-center cursor-pointer">
                                        <input
                                            type="checkbox"
                                            value="beraterPlanner"
                                            checked={consultantRoles.includes("beraterPlanner")}
                                            className="mr-2"
                                            onChange={(e) => {
                                                const updated = e.target.checked ? [...consultantRoles.filter(v => v !== ""), "beraterPlanner"] : consultantRoles.filter(v => v !== "beraterPlanner");
                                                setConsultantRoles(updated);
                                            }}
                                        />
                                        PM
                                    </label>
                                    <label className="flex items-center cursor-pointer">
                                        <input
                                            type="radio"
                                            value=""
                                            checked={consultantRoles.length === 0}
                                            className="mr-2"
                                            onChange={() => setConsultantRoles([])}
                                        />
                                        Keine
                                    </label>
                                </div>
                                )}
                            </div>

                            {/* Aktiv Checkbox - At Bottom */}
                            <div className="mb-6">
                                <label className="flex items-center cursor-pointer">
                                    <input
                                        type="radio"
                                        checked={isUserActive}
                                        onChange={(e) => setIsUserActive(e.target.checked)}
                                        className="mr-2"
                                    />
                                    <span className="font-medium">Aktiv</span>
                                </label>
                            </div>

                            {/* Action Buttons */}
                            <div className="flex gap-4 mt-6">
                                <button
                                    type="submit"
                                    disabled={!isValid}
                                    className={`flex-1 py-2 px-4 rounded text-white font-medium ${isValid ? 'bg-mainBlue hover:bg-blue-600' : 'bg-disableBlue'}`}
                                >
                                    {loading ? 'speichere...' : 'Benutzer speichern'}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setShowModal(false)}
                                    className="flex-1 py-2 px-4 rounded text-white bg-cancel hover:bg-red-600 font-medium"
                                >
                                    Abbrechen
                                </button>
                            </div>
                        </form>
                    </div>
                </div>)}
        </>);
};

export default UpdateRole;
